import { domToReact } from "html-react-parser";
import { ContactApi, WebApiContactDtoContactDto } from "../Repository/eventbookyapi";
import { GetApiConfiguration } from "./ServiceConfiguration";

export abstract class ContactService {

    public static SendContactMail = async (dto: WebApiContactDtoContactDto) => {
        return new ContactApi(GetApiConfiguration()).apiContactPost({ webApiContactDtoContactDto: dto });
    };

}